import { createDialogOperations } from "../../../ui/dialog-operations.ts";
import { escapeHtml } from "../../../ui/text.ts";

export function tableDialog(title: string, content: string, confirm: string, notify: (message: string, error?: boolean) => void, restoreFocus: () => void) {
  const dialog = document.createElement("dialog");
  dialog.className = "name-dialog task-table-dialog";
  dialog.setAttribute("aria-label", title);
  dialog.innerHTML = `<form><h2>${escapeHtml(title)}</h2>${content}<div class="dialog-actions"><button type="button" class="button button--soft" data-cancel>Cancel</button><button type="submit" class="button button--primary">${escapeHtml(confirm)}</button></div></form>`;
  const operations = createDialogOperations(dialog, notify);
  const close = () => { dialog.close(); dialog.remove(); restoreFocus(); };
  const cancel = () => { if (dialog.getAttribute("aria-busy") !== "true") close(); };
  dialog.querySelector("[data-cancel]")!.addEventListener("click", cancel);
  dialog.addEventListener("cancel", event => { event.preventDefault(); cancel(); });
  dialog.addEventListener("click", event => { if (event.target === dialog) cancel(); });
  document.body.append(dialog);
  dialog.showModal();
  return { dialog, operations, close };
}
